import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate, formatDateToPtbr, getUserNameToName, downloadFile } from '../../../utils/util';
import ContainerService from '../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Collapsible, Table } from '../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../utils/handleChangeHooks';
import SelectNew from '../../../components/UI/SelectNew';

const ContainerHistory = (props) => {
    const [currentPage, setCurrentPage] = useState({ pageSize: 20, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [containerHistoryList, setContainerContainerList] = useState([]);
    const [filter, setFilter] = useState({ internal: false });

    useEffect(() => {
        search();
        // eslint-disable-next-line

    }, []);

    useEffect(() => {
        setContainerContainerList([...props.containerHistoryList?.items || []]);
        // eslint-disable-next-line
    }, [props?.containerHistoryList?.items]);

    const search = () => {
        props.getContainerHistoryPaged(filter);
    }


    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };



    const configColumn = () => {
        const cols = [
            {
                field: 'name',
                body: (rowData) => rowData.container.name,
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'boardingCode',
                body: (rowData) => rowData.container.BoardingCode,
                header: 'Conhecimento',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerStatusDescription',
                header: 'Status Atual',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Status',
                align: 'left',
                sortable: false
            },
            {
                field: 'createdBy',
                header: 'Modificado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.createdBy),
                align: 'left',
            }
        ];
        return cols;
    };

    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `historico_container${Date.now()}.csv`, "data:text/csv", false);
        })
    }


    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Histórico de Container" }} />
            <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => exportCsv()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterSection"
                        header={translate('general:filters')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="containerOrLot"
                                                name='containerOrLot'
                                                label="Num. Container ou Lote"
                                                type="text"
                                                maxlength="11"
                                                value={filter?.containerOrLot || ''}
                                                onChange={onChange}
                                                onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); search(); } }}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="transportNumber"
                                                name='transportNumber'
                                                label='Conhecimento'
                                                type="text"
                                                maxlength="8"
                                                value={filter?.transportNumber || ''}
                                                onChange={onChange}
                                                onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); search(); } }}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s10">
                                            <SelectNew
                                                id="status"
                                                name="status"
                                                required
                                                value={filter?.status || ''}
                                                change={onChange}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                label="Status"
                                                data={props.containerStatus?.map((x) => ({ id: x.id, text: x.description }))}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                defaultValue={filter.dateStatus}
                                                type="date"
                                                label="Data Status"
                                                id="dateStatus"
                                                name="dateStatus"
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text={translate("general:search")} onClick={search} />
                                </div>
                            </>
                        }
                    />
                </div>
                <Table
                    totalPages={containerHistoryList.length / currentPage.pageSize}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={containerHistoryList}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        containerHistoryList: state.containerReducer.containerHistoryListPaged,
        containerStatus: state.containerReducer.containerStatus,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainerHistoryPaged: (filter, vision) => {
            dispatch(ContainerService.getContainerHistoryPaged(filter, vision));
        },
        getStatusContainer: (filter) => {
            dispatch(ContainerService.getStatusContainer(filter));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportContainerHistoryCsv(filter, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerHistory));
